import { render, staticRenderFns } from "./MultiselectTableSwitch.vue?vue&type=template&id=d0a3d578&scoped=true"
import script from "./MultiselectTableSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiselectTableSwitch.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MultiselectTableSwitch.vue?vue&type=style&index=0&id=d0a3d578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a3d578",
  null
  
)

export default component.exports